import { useEffect } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
import '../../assets/styles/compliance/DoughnutChart.scss';
import { theme } from '../../theme';

function addTotalCalls(jsonObj) {
  let total_call_volume = Object.values(jsonObj).reduce((sum, value) => sum + parseInt(value), 0);

  return total_call_volume;
}

function DoughnutChart({parentToChild}) {

  const { mode, callSummaryData } = parentToChild;

  var CanvasJSChart = CanvasJSReact.CanvasJSChart;

  const options = {
    backgroundColor: mode === 'light' ? 'white': '#201c24',
    animationEnabled: true,
    subtitles: [{
      text: callSummaryData ? addTotalCalls(callSummaryData) : 0,
      verticalAlign: "center",
      fontSize: 50,
      fontColor: mode === 'light' ? 'black': 'white',
      dockInsidePlotArea: true,
      fontFamily: theme.fonts.secondary,
    }],
    data: [{
      type: "doughnut",
      // showInLegend: true,
      indexLabel: "{y}",
      indexLabelPlacement: "inside",
      indexLabelFontColor: "white",
      yValueFormatString: "#,###''",
      // yValueFormatString: "#,###'K'",
      fontFamily: theme.fonts.primary,
      dataPoints: [
          { name: "Voicemail", y: callSummaryData ? callSummaryData.voicemail_count : 0, color: '#2e2e38' },
          { name: "Non-Customer Answered", y: callSummaryData ? callSummaryData.non_customer_count : 0, color: '#c4c4cd' },
          { name: "Customer Busy", y: callSummaryData ? callSummaryData.customer_busy_count : 0, color: '#c8b424' },
          { name: "Customer Answered", y: callSummaryData ? callSummaryData.customer_answered_count : 0, color: theme.colors.primary }
      ]
    }]
  }

  const listData = [
    { name: "Voicemail", color: '#2e2e38' },
    { name: "Non-Customer Answered", color: '#c4c4cd' },
    { name: "Customer Busy", color: '#c8b424' },
    { name: "Customer Answered", color: theme.colors.primary },
  ];

  useEffect(() => {
    const list = document.getElementById('list');
    if (list) {
      list.innerHTML = '';
      listData.forEach((item, index) => {
        const listItem = document.createElement('li');
        listItem.textContent = item.name;
        listItem.innerHTML += `<style>ul li:nth-child(${index + 1})::before { background-color: ${item.color} }</style>`;
        list.appendChild(listItem);
      });
    }
    // eslint-disable-next-line
  }, []);

  const containerProps = {
      height: "180px",
      width: "50%",
  };

  return (
    <div className='canvasjs-chart agenteffect-donut-chart'>
      <CanvasJSChart containerProps={containerProps} options = {options}
      />
      <ul id="list"></ul>
    </div>
  );
}

export default DoughnutChart;